import { render, staticRenderFns } from "./silent.vue?vue&type=template&id=9b74556e&"
import script from "./silent.vue?vue&type=script&lang=js&"
export * from "./silent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports